import React, { useEffect, useState } from 'react';
import {
  getSubscriptions,
  saveSubscription,
  deleteSubscription,
  markSubscriptionInactive,
} from '../service';
// import { SUBSCRIPTIONS } from '../constants';
import { handleAPIError } from '../../../utils/apiUtils';

const useSubscriptionState = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSubscriptions = async () => {
    try {
      setLoading(true);
      const data = await getSubscriptions();
      setSubscriptions(data);
    } catch (error) {
      console.error('Failed to fetch subscriptions', error);
      // setSubscriptions(SUBSCRIPTIONS);
    } finally {
      setLoading(false);
    }
  };

  const sortAndSetSubscriptions = (subscriptionsLists) => {
    subscriptionsLists.map(subscriptionsList => {
      subscriptionsList.subscription_items.sort((a, b) => {
        if (a.is_active !== b.is_active) {
          return b.is_active - a.is_active;
        }

        if (a.product.name.toLowerCase() < b.product.name.toLowerCase()) return -1;
        if (a.product.name.toLowerCase() > b.product.name.toLowerCase()) return 1;
        return 0;
      });
      return subscriptionsList;
    })
    setSubscriptions(subscriptionsLists);
  }

  const addOrUpdate = async (subscription) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };
    try {
      const saved = await saveSubscription(subscription);
      response.success = true;
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to save subscription', error);
    }
    return response;
  };

  const remove = async (id) => {
    try {
      await deleteSubscription(id);
      const updatedSubscriptions = subscriptions.filter(c => c.id !== id);
      sortAndSetSubscriptions(updatedSubscriptions);
    } catch (error) {
      console.error('Failed to delete subscription', error);
    }
  };

  const markInactive = async (customer_id, id, date) => {
    try {
      await markSubscriptionInactive(id, date);
      const updatedSubscriptions = subscriptions.map(customer => {
        if (customer.customer_id === customer_id) {
          return {
            ...customer,
            subscription_items: customer.subscription_items.map(item =>
              item.id === id ? { ...item, is_active: !item.is_active, last_deactivation_date: date } : item
            ),
          }
        }
        return customer;
      });
      sortAndSetSubscriptions(updatedSubscriptions);
    } catch (error) {
      console.error('Failed to mark inactive the subscription', error);
    }
  }

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  return { subscriptions, loading, addOrUpdate, remove, markInactive };
};

export default useSubscriptionState;
